import React, { useEffect, useState } from "react";

import { Bar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import PropTypes from "prop-types";

const BarChartEntry = props => {
  // console.log(props.modelDeviceList);
  function numberFormat(number, digit = 2) {
    if (number === null || number === "null" || number === "") return "";
    function isFloat(n) {
      return Number(n) === n && n % 1 !== 0;
    }
    if (typeof number == "string") {
      if (number.includes("+")) {
        return (
          "+ " +
          parseFloat(number.replaceAll("+", "").trim())
            .toFixed(digit)
            .toLocaleString(undefined, {
              minimumFractionDigits: digit,
            })
        );
      }
      if (number.includes("-")) {
        return (
          "- " +
          parseFloat(number.replaceAll("-", "").trim())
            .toFixed(digit)
            .toLocaleString(undefined, {
              minimumFractionDigits: digit,
            })
        );
      }
    }
    if (isFloat(number))
      return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
        minimumFractionDigits: digit,
      });
    return parseFloat(number).toLocaleString(undefined, {
      minimumFractionDigits: digit,
    });
  }
  const [data, setData] = useState({
    labels: [],
    datasets: [
      {
        label: "Plan Entry",
        backgroundColor: "#F898A4", //#437AD5
        borderColor: "#FFFFFF",
        barPercentage: 0.7,
        borderWidth: 1,
        hoverBorderWidth: 3,
        hoverBackgroundColor: "#F898A4", //#437AD5
        hoverBorderColor: "#FFFFFF",
        data: [],
        datalabels: {
          anchor: "end",
          align: "top",
          offset: 1,
          color: "#F898A4",
          formatter: function (value, context) {
            if (value == 0) {
              return "";
            }
            return numberFormat(value, 0);
          },
          font: {
            weight: 'bold',
            size: 14,
          }
        },
      },
      {
        label: "Actual Entry",
        backgroundColor: "#FBCCC2",// #59B7E7
        borderColor: "#FFFFFF",
        barPercentage: 0.7,
        borderWidth: 1,
        hoverBackgroundColor: "#FBCCC2", //#59B7E7
        hoverBorderColor: "#FFFFFF",
        hoverBorderWidth: 3,
        data: [],
        datalabels: {
          anchor: "end",
          align: "top",
          offset: 1,
          color: "#FBCCC2",
          formatter: function (value, context) {
            if (value == 0) {
              return "";
            }
            return numberFormat(value, 0);
          },
          font: {
            weight: 'bold',
            size: 14,
          }
        },
      },
    ],
  });

  const option = {

    maintainAspectRatio: false,
    scales: {
      dataset: [
        {
          barPercentage: 0.4,
        },
      ],
      xAxes: [
        {
          display: true,
          scaleLabel: {
            display: true,
            fontSize: 15,
            labelString: "Supply-Demand",
            fontColor: "#FFFFFF",
            fontStyle: "bold",
          },
          gridLines: {
            display: true,
          },
          ticks: {
            fontColor: "#FFFFFF",
            fontStyle: "bold",
            fontSize: 15,
          },
        },
      ],
      yAxes: [
        {
          display: true,
          scaleLabel: {
            display: true,
            fontSize: 15,
            labelString: "MMscf",
            fontColor: "#FFFFFF",
            position: "left",
            fontStyle: "bold",
          },
          gridLines: {
            display: true,
          },
          ticks: {
            stepSize: 1000,
            fontColor: "#FFFFFF",
            fontStyle: "bold",
            fontSize: 15,
            // max:0,
            min: 0,
            callback: function (label, index, labels) {
              var val = Math.abs(label);
              // if (val >= 1000) {
              //   if (label < 0) {
              //     val = val * -1;
              //   }
              //   val = numberFormat(val / 1000, 1) + " K";
              // } else {
              if (label < 0) {
                val = val * -1;
              }
              val = numberFormat(val, 0);
              // }

              return val;
            },
          },
        },
      ],
    },
    tooltips: {
      enabled: true,
      mode: 'nearest',
      intersect: false,
      titleFontSize: 20,
      bodyFontSize: 18,
      bodyFontStyle: "bold",
      callbacks: {
        label: function (tooltipItem, data) {
          // console.log(tooltipItem);
          // console.log(data);
          // var indice = tooltipItem.index;
          return " " + numberFormat(tooltipItem.yLabel, 0);
        }
      },
    },
    legend: {
      labels: {
        fontColor: "#FFFFFF",
        fontStyle: "bold",
        fontSize: 14,
      },
    },
  };
  useEffect(() => {
    let newList = props.modelDeviceList.filter(
      item => item.SUPPLYDEMAND_NAME != "Total"
    );
    let groupData = newList.reduce((group, item) => {
      const { EXIT_SUPPLYDEMAND_ZONE } = item;
      group[EXIT_SUPPLYDEMAND_ZONE] = group[EXIT_SUPPLYDEMAND_ZONE] ?? [];
      group[EXIT_SUPPLYDEMAND_ZONE].push(item);
      return group;
    }, {});

    // console.log(groupData);
    let newEntryList = Object.keys(groupData)
      .map(key => {
        if (groupData[key].length > 1) {
          let sumPlanEntry = groupData[key].map(item => item.SUPPLY_PLAN_ENTRY).reduce((prev, curr) => prev + curr, 0);
          let sumActualEntry = groupData[key].map(item => item.SUPPLY_ACTUAL_ENTRY).reduce((prev, curr) => prev + curr, 0);
          return {
            ...groupData[key][0],
            SUPPLYDEMAND_NAME: groupData[key][0].EXIT_SUPPLYDEMAND_ZONE,
            SUPPLY_PLAN_ENTRY: sumPlanEntry,
            SUPPLY_ACTUAL_ENTRY: sumActualEntry
          };
        }
        return { ...groupData[key][0] };
      })
      .sort((a, b) =>
        a.ENTRY_ROW > b.ENTRY_ROW ? 1 : b.ENTRY_ROW > a.ENTRY_ROW ? -1 : 0
      );

    let merge = newList.filter(item => item.ENTRY_groups != null).reduce((group, item) => {
      const { ENTRY_groups } = item;
      group[ENTRY_groups] = group[ENTRY_groups] ?? [];
      group[ENTRY_groups].push(item);
      return group;
    }, {});
    Object.keys(merge).map(key => {
      newEntryList = newEntryList.filter(item => item.ENTRY_groups != key)
      newEntryList.push({ ...merge[key][0], SUPPLYDEMAND_NAME: merge[key][0].EXIT_SUPPLYDEMAND_ZONE })
    })
    newEntryList = newEntryList.sort((a, b) =>
      a.ENTRY_ROW > b.ENTRY_ROW ? 1 : b.ENTRY_ROW > a.ENTRY_ROW ? -1 : 0
    );
    // console.log(newEntryList);
    let labels = newEntryList.map(item => item.SUPPLYDEMAND_NAME.indexOf(',') >= 0 ? item.SUPPLYDEMAND_NAME.substring(0, item.SUPPLYDEMAND_NAME.indexOf(',')) : item.SUPPLYDEMAND_NAME);

    let planEntryData = newEntryList.map(item =>
      item.SUPPLY_PLAN_ENTRY
    );
    let actualEntryData = newEntryList.map(item =>
      item.SUPPLY_ACTUAL_ENTRY
    );
    setData(prev => {
      return {
        ...prev,
        labels: labels,
        datasets: [
          { ...prev.datasets[0], data: planEntryData },
          { ...prev.datasets[1], data: actualEntryData },
        ],
      };
    });
    // console.log(props.modelDeviceList);
  }, [props.modelDeviceList]);
  return (
    <React.Fragment>
      <Bar data={data} options={option} plugins={[ChartDataLabels]} />
    </React.Fragment>
  );
};
BarChartEntry.propTypes = {
  t: PropTypes.any,
  date: PropTypes.any,
  summaryReportPid: PropTypes.any,
  modelDeviceList: PropTypes.any,
};
export default BarChartEntry;
